import { IProfileUser } from '@giphy/js-types'
import React, { PureComponent } from 'react'
import pingbackEnhancer from 'shared/pingbacks/pingback-enhancer'
import Avatar from './avatar'
// @ts-ignore
import styles from './avatar-badge.css'
import UsernameBadge from './username-badge'

type PingbackFunctions = { onClick: (props: any) => void; onHover: (props: any) => void }
type Props = {
    user: IProfileUser
    title: string
    height: number
    onClick: () => void
    css: any
    pingBackFunctions?: PingbackFunctions
}
class AvatarBadge extends PureComponent<Props> {
    static defaultProps = {
        user: {},
        css: {},
    }
    click() {
        this.props.pingBackFunctions?.onClick(this.props)
    }
    onHover() {
        this.props.pingBackFunctions?.onHover(this.props)
    }
    el: HTMLDivElement | null
    render() {
        const { user, title, height, onClick, css } = this.props
        const { titleStyle = styles.title, containerStyle = styles.container, profileStyle = styles.profileInfo } = css
        return (
            <div
                ref={el => {
                    this.el = el
                }}
                onMouseEnter={() => this.onHover()}
                className={containerStyle}
                onClick={() => {
                    this.click()
                    onClick && onClick()
                }}
            >
                <Avatar user={user} height={height} />
                <div className={profileStyle}>
                    <a href={user.profile_url.slice(0, -1)}>
                        <h1 className={titleStyle}>{title}</h1>
                    </a>
                    <div className={styles.usernameClass}>
                        <UsernameBadge user={user} tooltip={false} />
                    </div>
                </div>
            </div>
        )
    }
}

export default pingbackEnhancer()(AvatarBadge)
